import {
  Autocomplete,
  Box,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import { arrayOf, func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const MetricRuleRow = ({ condition, tags, onChange, onRemove }) => {
  const value = tags.find(t => String(t._id) === String(condition.tagId)) || null;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto auto minmax(180px, 1fr) auto',
        alignItems: 'center',
        gap: 1.5,
        py: 1,
      }}
    >
      <Select
        size="small"
        sx={{ minWidth: 88 }}
        data-testid="metric-rule-operator"
        value={condition.operator || 'has'}
        onChange={e => onChange({ ...condition, operator: e.target.value })}
      >
        <MenuItem value="has">{I18n.t('AgenticChatFlow.MetricsOperatorHas')}</MenuItem>
        <MenuItem value="not">{I18n.t('AgenticChatFlow.MetricsOperatorNot')}</MenuItem>
      </Select>
      <Typography sx={{ fontSize: theme => theme.typography.pxToRem(13), color: 'text.secondary' }}>
        {I18n.t('AgenticChatFlow.MetricsRuleTagLabel')}
      </Typography>
      <Box data-testid="metric-rule-tag">
        <Autocomplete
          size="small"
          options={tags}
          getOptionLabel={opt => opt?.name || ''}
          value={value}
          isOptionEqualToValue={(opt, val) => String(opt._id) === String(val._id)}
          onChange={(_, next) => onChange({ ...condition, tagId: next?._id || null })}
          renderInput={params => (
            <TextField
              {...params}
              placeholder={I18n.t('AgenticChatFlow.MetricsRuleTagPlaceholder')}
            />
          )}
        />
      </Box>
      <IconButton
        size="small"
        sx={{ color: 'text.secondary' }}
        data-testid="metric-rule-remove"
        onClick={onRemove}
      >
        <DeleteOutlineIcon size={18} />
      </IconButton>
    </Box>
  );
};

MetricRuleRow.propTypes = {
  condition: object.isRequired,
  tags: arrayOf(object).isRequired,
  onChange: func.isRequired,
  onRemove: func.isRequired,
};

export default MetricRuleRow;
